namespace $.$$ {
	
	$mol_style_define( $giper_baza_glob_book, {
		
		Menu: {
			flex: {
				basis: `25rem`,
			},
		},
		
		Menu_link: {
			whiteSpace: 'pre-wrap',
			font: {
				family: 'monospace',
			}
		},
		
		Land_add: {
			Trigger: {
				justify: {
					content: 'center',
				},
			},
		},
		
		Rights_page: {
			flex: {
				basis: `35rem`,
			},
		},
		
	} )
	
}
